import { call, put, takeEvery, select, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchSearchLocationAPI, searchLocationSuggestionsApi,searchStateSuggestionsApi,searchRegionSuggestionsApi, searchCompaniesAndIndustriesApi, searchSkillsApi } from "../../API/API";
import { fetchLocationFailure, 
  fetchCitySuggestionsFailure,
   fetchStateSuggestionsFailure ,
   fetchRegionSuggestionsFailure,
   fetchKeySearchDynamicLocationFailure,
   fetchKeySearchCompanyAndIndustriesFailure,
   fetchKeySearchSkillsFailure} from "../actions";

function* searchLocationSaga(params) {
  try {
    yield put({ type: types.FETCH_SEARCH_LOCATION_PENDING });
    
    const response = yield call(fetchSearchLocationAPI, params); // API Backend
    yield put({
      type: types.FETCH_SEARCH_LOCATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put(fetchLocationFailure(error));
  }
}

// state
function* searchStateSuggestionsSaga(params) {
   try {
    const response = yield call(searchStateSuggestionsApi, params); // API Backend
    yield put({
      type: types.FETCH_STATE_SUGGESTIONS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put(fetchStateSuggestionsFailure(error));
  }
}
// region
function* searchRegionSuggestionsSaga(params) {
  try {
    const response = yield call(searchRegionSuggestionsApi, params); // API Backend
    yield put({
      type: types.FETCH_REGION_SUGGESTIONS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put(fetchRegionSuggestionsFailure(error));
  }
}

function* searchLocationSuggestionsSaga(params) {
  try {
    let response = yield call(searchLocationSuggestionsApi, params); // API Backend
    if(params?.payload?.value){
      response.data.value = params?.payload?.value;
    }
    if(response?.data){
      yield put({
        type: types.FETCH_SEARCH_DYNAMIC_LOCATION_SUCCESS,
        payload: response.data,
      });
    }else{
      yield put(fetchKeySearchDynamicLocationFailure());
    }
  } catch (error) {
    yield put(fetchKeySearchDynamicLocationFailure(error));
  }
}

function* searchCompaniesAndIndustriesSaga(params) {
  try {
    let response = yield call(searchCompaniesAndIndustriesApi, params); // API Backend
    if(response?.data){
      yield put({
        type: types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_SUCCESS,
        payload: response?.data,
      });
    }else{
      yield put(fetchKeySearchCompanyAndIndustriesFailure());
    }
  } catch (error) {
    yield put(fetchKeySearchCompanyAndIndustriesFailure(error));
  }
}

function* searchSkillsSaga(params) {
  try {
    let response = yield call(searchSkillsApi, params); // API Backend
    if(response?.data){
      yield put({
        type: types.FETCH_SEARCH_SKILLS_SUCCESS,
        payload: response?.data,
      });
    }else{
      yield put(fetchKeySearchSkillsFailure());
    }
  } catch (error) {
    yield put(fetchKeySearchSkillsFailure(error));
  }
}

export function* watchSearchLocationSaga() {
  yield takeEvery(types.FETCH_SEARCH_LOCATION_INIT, searchLocationSaga);
}

export function* watchSearchStateSuggestionsSaga() {
  yield takeEvery(types.FETCH_STATE_SUGGESTIONS_INIT, searchStateSuggestionsSaga);
}
export function* watchSearchRegionSuggestionsSaga() {
  yield takeEvery(types.FETCH_REGION_SUGGESTIONS_INIT, searchRegionSuggestionsSaga);
}
export function* watchSearchLocationSuggestionsSaga() {
  yield takeLatest(types.FETCH_SEARCH_DYNAMIC_LOCATION_INIT, searchLocationSuggestionsSaga);
}
export function* watchSearchCompaniesAndIndustriesSaga() {
  yield takeLatest(types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_INIT, searchCompaniesAndIndustriesSaga);
}
export function* watchSearchSkillsSaga() {
  yield takeLatest(types.FETCH_SEARCH_SKILLS_INIT, searchSkillsSaga);
}